import { axiosInstanceV3, axiosNestJsInstance } from "@mais-retorno-front/configs/axios-config";
import { IColorHelper } from "@mais-retorno-front/core-business/interfaces/color";
import { IFundComparisonBookmarkCreated } from "@mais-retorno-front/core-business/interfaces/fund-comparison-bookmark";
import { IInMemoryRepo } from "@mais-retorno-front/core-business/interfaces/memory";
import { makeCatchIssueUseCase } from "../catch-issue.factory";
import { GetBookmarkAssetsUseCase } from "@mais-retorno-front/core-business/useCases/bookmark-asset/get-bookmark-assets.usecase";
import { marketData } from "@core/market-data-sdk";

const catchIssueUseCase = makeCatchIssueUseCase();

interface IMakeGetBookmarkAssetsProps {
  colorRepository: IColorHelper;
  memoryRepository: IInMemoryRepo<IFundComparisonBookmarkCreated>,
}

export const makeGetBookmarkAssets = ({
  colorRepository,
  memoryRepository,
}: IMakeGetBookmarkAssetsProps) => {
  const url = "/bookmarks/asset/";
  const http = axiosNestJsInstance;
  const httpApi = marketData;

  return new GetBookmarkAssetsUseCase(
    url,
    http,
    httpApi,
    colorRepository,
    memoryRepository,
    catchIssueUseCase
  );
}